import React, { useLayoutEffect, useRef } from 'react';
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

interface ProjectReviewsProps {
	activeIndex: number,
	setActiveIndex: (newIndex: number) => void,
	containerAnimation?: any,
}

export const titleOptions = [
	{
		title: "Project review from the team",
	},
	{
		title: "Step-by-step guide to participating in the project"
	},
	{
		title: "Project Evaluation.",
		description: "Quick information about all important points in a particular activity"
	},
	{
		title: "All important updates right inside the card"
	}
];

const ProjectReviewsComponent = (props: ProjectReviewsProps) => {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const contentRef = useRef<HTMLDivElement | null>(null);
	
	useLayoutEffect(() => {
		let ctx = gsap.context(() => {
			
			gsap.registerPlugin(ScrollTrigger);
			
			if (!contentRef.current) return;
			
		 const sections = gsap.utils.toArray(".projectReviewsComponent__content_data");
			
			ScrollTrigger.create({
				containerAnimation: props.containerAnimation,
				trigger: containerRef.current,
				start: "center center",
				end: "+=2000",
				scrub: true,
				pin: true,
				onUpdate: (self) => {
				}
			});
		});
		return () => {
			ctx.revert();
		};
	}, [containerRef]);
	
	return (
		<div className="projectReviewsComponent" ref={containerRef}>
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="projectReviewsComponent__content" ref={contentRef}>
				<div className="projectReviewsComponent__content_data">
					{
						titleOptions.map((item, index) => (
							<div
								key={`${item.title} - ${index}`}
								className={`projectReviewsComponent__content_data_item ${props.activeIndex === index + 1 ? 'active' : ''}`}
								onClick={() => props.setActiveIndex(index + 1)}
							>
								<h3>{item.title}</h3>
								{item.description && <span>{item.description}</span>}
							</div>
						))
					}
				</div>
				<div className="projectReviewsComponent__content_images">
					<div
						className={`projectReviewsComponent__content_images_image idx_1 ${props.activeIndex === 1 ? 'active' : ''}`}
					>
						<img
							src={`${process.env.PUBLIC_URL}/assets/images/nfdPlatform/projectReviews/image1.webp`}
							alt={`Review - 1`}
						/>
					</div>
					<div
						className={`projectReviewsComponent__content_images_image idx_2 ${props.activeIndex === 2 ? 'active' : ''}`}
					>
						<img
							src={`${process.env.PUBLIC_URL}/assets/images/nfdPlatform/projectReviews/image2.webp`}
							alt={`Review - 2`}
						/>
					</div>
					<div
						className={`projectReviewsComponent__content_images_image idx_3 ${props.activeIndex === 3 ? 'active' : ''}`}
					>
						<img
							src={`${process.env.PUBLIC_URL}/assets/images/nfdPlatform/projectReviews/image3.webp`}
							alt={`Review - 3`}
						/>
					</div>
					<div
						className={`projectReviewsComponent__content_images_image idx_4 ${props.activeIndex === 4 ? 'active' : ''}`}
					>
						<img
							src={`${process.env.PUBLIC_URL}/assets/images/nfdPlatform/projectReviews/image4.webp`}
							alt={`Review - 4`}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProjectReviewsComponent;

